import { useContext, useState } from 'react';

import CadModel from '@lcsc-ui/components/CadModel';
import SvgIcon from '@lcsc-ui/components/SvgIcon';
import { LayoutContext } from '@lcsc-ui/layouts/baseLayout/provider';
import useUserStore from '@lcsc-ui/store/user';
import { buriedPoint } from '@lcsc-ui/utils/buriedPoint';
import sendAxios from '@lcsc-ui/utils/request';
import { Modal } from 'antd';

import apis from '@/apis';
import Image from '@/components/Image';
import useProductStore from '@/store/product';

export default function ProductBtn({ data }) {
  const fromZone = useUserStore((state) => state.fromZone);
  const [isShowEda, setIsShowEda] = useState(false);
  const [simple, setSimple] = useState({});
  const [isShowCadModel, setIsShowCadModel] = useState(false);
  const [dataSheetUrl] = useState(data?.dataSheetUrl);
  const { productAsyncData } = useProductStore();
  const { resourceData } = useContext(LayoutContext);
  const { projectConfigVO } = resourceData;
  const productRecord = data?.productRecord;
  const showType = [
    'pdf_property',
    'certification_data_property',
    'industry_information',
    'reference_designs_property',
  ];
  const pdfUrl =
    data?.productRecord?.fileTypeVOList &&
    data.productRecord.fileTypeVOList.filter((item) => showType.includes(item.fileType)).length > 0 &&
    data.productRecord.fileTypeVOList.filter((item) => showType.includes(item.fileType))[0]?.detailVOList?.length > 0;

  const clickIsEda = () => {
    if (productRecord?.inEdaWhiteList) {
      window.open('https://oshwhub.com/rewards/f4bbab6365034e80aadb8f8ebf77c846');
    } else {
      sendAxios({
        method: 'get',
        baseURL: 'lcscItemUrl',
        url: `${apis.bomSimple}/${productRecord?.bomMainUuid}`,
      }).then((res) => {
        setSimple(res.result);
        setIsShowEda(true);
      });
    }
  };

  const handleCancel = () => {
    setIsShowEda(false);
  };

  const clickPdf = (isOpen) => {
    if (data?.isOversea) {
      buriedPoint({
        ty: 'click',
        cp: 'product_detail',
        op: 'click_pdf',
        data: {
          track_zone: fromZone,
          xh: data?.productCodeManufacturer,
        },
      });
    } else {
      buriedPoint({ ty: 'click', cp: 'product_detail', op: 'click_pdf', data: { pc: data?.productRecord?.productId } });
    }
    if (isOpen) {
      setIsShowCadModel(true);
    } else {
      window.open(dataSheetUrl, '_blank');
    }
  };

  const clickBom = () => {
    buriedPoint({
      ty: 'click',
      cp: 'product_detail',
      op: 'verification_bom',
      data: { pc: data?.productRecord?.productId },
    });
  };

  return (
    <ul className="flex items-center text-[14px]">
      {pdfUrl && (
        <li>
          <button
            id="item-pdf"
            className="w-[124px] hover:border-[#0093E6] bg-[white] mr-[20px] h-[40px] border-[#ABB5C9] border-solid border-[1px] rounded-[4px] text-[#0093E6] flex items-center justify-center hover:opacity-[0.8]"
            aria-label={`打开${productRecord.productModel}规格书`}
            target="_blank"
            onClick={() => clickPdf(true)}
          >
            <SvgIcon app="item" iconName="pdf" className="w-[22px] h-[20px]" />
            <span className="ml-[8px]">数据手册</span>
          </button>
        </li>
      )}
      {dataSheetUrl && (
        <li>
          <button
            id="item-pdf"
            className="w-[124px] hover:border-[#0093E6] bg-[white] h-[40px] border-[#ABB5C9] border-solid border-[1px] rounded-[4px] text-[#0093E6] mr-[20px] flex items-center justify-center hover:opacity-[0.8]"
            aria-label={`打开${productRecord.productModel}规格书`}
            target="_blank"
            onClick={() => clickPdf(false)}
          >
            <SvgIcon app="item" iconName="pdf" className="w-[22px] h-[20px]" />
            <span className="ml-[8px]">数据手册</span>
          </button>
        </li>
      )}
      {productRecord?.bomMainUuid && productAsyncData?.productRecord?.productUnsealVendition === 'yes' ? (
        <>
          <button
            id="item-yzb"
            className="w-[124px] h-[40px] hover:border-[#0093E6] bg-[white] border-[#ABB5C9] border-solid border-[1px] rounded-[4px] text-[#0093E6] flex items-center justify-center hover:opacity-[0.8]"
            onClick={clickIsEda}
          >
            <SvgIcon app="item" iconName="isEda" className="w-[20px] h-[20px]" />
            <span className="ml-[8px]">{productRecord?.inEdaWhiteList ? '申请设计验证板' : '免费验证板'}</span>
          </button>
        </>
      ) : (
        <></>
      )}
      <Modal
        data-spm="xyz"
        width={600}
        title="免费验证板"
        open={isShowEda}
        onCancel={handleCancel}
        footer={null}
        centered
      >
        <ul className="flex justify-around mt-[30px]">
          {productRecord?.blankBoardId && (
            <li className="cursor-pointer hover:text-[#0093E6] text-center">
              <a
                href={`${projectConfigVO.lcscItemUrl}/${productRecord?.blankBoardId}.html`}
                target="_blank"
                data-spm="pcb"
              >
                <Image
                  className="m-auto mb-[17px]"
                  src="https://static.szlcsc.com/ecp/assets/web/page/item/details/images/mfyzb4.png"
                  alt="免费验证板PCB"
                  width={52}
                  height={56}
                />
                <p>免费验证板PCB</p>
              </a>
            </li>
          )}
          {simple?.bomDetailList && simple?.bomDetailList?.length && (
            <li className="cursor-pointer hover:text-[#0093E6] text-center">
              <a
                href={`${projectConfigVO?.lcscSearchUrl}/bom/${productRecord?.bomMainUuid?.toLowerCase()}.html`}
                target="_blank"
                onClick={clickBom}
                data-spm="bom"
              >
                <Image
                  className="m-auto mb-[17px]"
                  src="https://static.szlcsc.com/ecp/assets/web/page/item/details/images/mfyzb5.png"
                  alt="配套BOM一键下单"
                  width={52}
                  height={56}
                />
                <p>配套BOM一键下单</p>
              </a>
            </li>
          )}
          {simple?.icDataUrl && simple?.urlSign && (
            <li className="cursor-pointer hover:text-[#0093E6] text-center">
              <a
                href={`${projectConfigVO?.lcscAttaUrl}${simple?.icDataUrl}${simple?.urlSign}`}
                target="_blank"
                data-spm="ic"
              >
                <Image
                  className="m-auto mb-[17px]"
                  src="https://static.szlcsc.com/ecp/assets/web/page/item/details/images/mfyzb6.png"
                  alt="技术资料与测评报告"
                  width={52}
                  height={56}
                />
                <p>技术资料与测评报告</p>
              </a>
            </li>
          )}
          {productRecord?.lcedaProjectUrl && (
            <li className="cursor-pointer hover:text-[#0093E6] text-center">
              <a href={productRecord?.lcedaProjectUrl} target="_blank" data-spm="eda">
                <Image
                  className="m-auto mb-[17px]"
                  src="https://static.szlcsc.com/ecp/assets/web/page/item/details/images/mfyzb7.png"
                  alt="立创EDA工程链接"
                  width={52}
                  height={56}
                />
                <p>立创EDA工程链接</p>
              </a>
            </li>
          )}
        </ul>
      </Modal>
      {isShowCadModel && (
        <CadModel product={productRecord} open={isShowCadModel} onCancel={() => setIsShowCadModel(false)} />
      )}
    </ul>
  );
}
